import { DefaultLayout } from '@c/layouts';
import SEO from '@c/SEO';
import TermsAndConditionsPage from '@c/TermsAndConditionsPage';
import React from 'react';

const TermsAndConditions = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="GearFocus terms and conditions govern buying and selling used camera gear on our marketplace. Review our platform rules and policies."
      />
      <TermsAndConditionsPage />
    </>
  );
};

TermsAndConditions.getLayout = function getLayout(page: React.ReactElement) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export default TermsAndConditions;
